// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ede2cc13","337":"d2d043db","453":"68693753","455":"9abd908a"}[chunkId] + ".chunk.js";
};